<template>
  <pt-show-calculate-result class="pt-show-calculate-result__page"></pt-show-calculate-result>
</template>

<script>
import PtShowCalculateResult from 'cps/gene-product/pt-show-calculate-result/withData'
export default {
  name: 'pt-show-calculate-result__view',
  components: {
    'pt-show-calculate-result': PtShowCalculateResult
  }
}
</script>
